exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload-img-5[data-v-38eb9eb1]{margin:5px 0 90px 0}.upload-img-1[data-v-38eb9eb1]{margin:5px 0 15px 0}", ""]);

// exports
